import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

export const BalanceSheetWrapper = styled(Row)`
  > div {
    &:first-child {
      padding-right: ${({ theme }) => theme.x1spacePx}px;
    }
    &:last-child {
      padding-left: ${({ theme }) => theme.x1spacePx}px;
    }
    ${media.mdDown`
    &:first-child,
    &:last-child {
        padding-right: 0;
        padding-left: 0;
    }
  `}
  }
`;
